import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { GetClaimFeatureRepository, GetClaimCompareMatchRepository, GetResultPositionRepository, GetClaimCompareTranslationRepository, GetClaimCompareExportRepository, SetClaimCompareTranslationCacheRepository, GetClaimCompareResultRepository, GetComparePatentRepository } from './services/claim-charting-repository';
import { ClaimChartingRepositoryImpl } from './repositories/impls/claim-charting-repository';
import { FeatureDismantlingService } from './services/feature-dismantling-service';
import { FeatureDismantlingServiceImpl } from './services/impls/feature-dismantling-service';
import { FeatureDismantlingModel } from './models/feature-dismantling-model';
import { FeatureDismantlingModelImpl } from './models/impls/feature-dismantling-model';
import { FeatureCompareService } from './services/feature-compare-service';
import { FeatureCompareServiceImpl } from './services/impls/feature-compare-service';
import { FeatureCompareModel } from './models/feature-compare-model';
import { FeatureCompareModelImpl } from './models/impls/feature-compare-model';
import { FeatureLocatedService } from './services/feature-located-service';
import { FeatureLocatedServiceImpl } from './services/impls/feature-located-service';
import { FeatureLocatedModel } from './models/feature-located-model';
import { FeatureLocatedModelImpl } from './models/impls/feature-located-model';
import { AddComparePatentService } from './services/add-compare-patent-service';
import { AddComparePatentServiceImpl } from './services/impls/add-compare-patent-service';
import { ExportExcelServiceImpl } from './services/impls/export-excel-service';
import { ExportExcelService } from './services/export-excel-service';


export const claimChartingModule = (bind: interfaces.Bind) => {
    bind(GetClaimFeatureRepository).to(ClaimChartingRepositoryImpl);
    bind(GetClaimCompareMatchRepository).to(ClaimChartingRepositoryImpl);
    bind(GetResultPositionRepository).to(ClaimChartingRepositoryImpl);
    bind(GetClaimCompareTranslationRepository).to(ClaimChartingRepositoryImpl);
    bind(GetClaimCompareExportRepository).to(ClaimChartingRepositoryImpl);
    bind(SetClaimCompareTranslationCacheRepository).to(ClaimChartingRepositoryImpl);
    bind(GetClaimCompareResultRepository).to(ClaimChartingRepositoryImpl);
    bind(GetComparePatentRepository).to(ClaimChartingRepositoryImpl);
    bind(FeatureDismantlingService).to(FeatureDismantlingServiceImpl);
    bind(FeatureDismantlingModel).to(FeatureDismantlingModelImpl);
    bind(FeatureCompareService).to(FeatureCompareServiceImpl);
    bind(FeatureCompareModel).to(FeatureCompareModelImpl);
    bind(FeatureLocatedService).to(FeatureLocatedServiceImpl);
    bind(FeatureLocatedModel).to(FeatureLocatedModelImpl);
    bind(AddComparePatentService).to(AddComparePatentServiceImpl);
    bind(ExportExcelService).to(ExportExcelServiceImpl);
};
